<template lang="pug">
  //- 新版电商返佣
  CommonLoadBox(:loaded="rakeBackloaded")
    template(slot='skeleton')
      RakeBackSkeleton
    template(slot='module')
      component(
        :is="currentCashbackComponent"
        v-platform-expose="moduleExpose"
        v-if="!reload"
        ref="cashbackPurchaseRef"
        :rakeBackModuleInfo="rakeBackModuleInfo"
        @bounty="handleBountyRefresh"
        @loaded="handleLoaded"
      )
</template>

<script>
import CommonLoadBox from '@/components/common-load-box';
import SPM from '../../common/spm';
import { MODULE_KEY_CASHBACK_STYLE } from '../../consts';
import CashbackPurchase from './cashback-purchase';
import CashbackPurchaseV2 from './cashback-purchase-v2/cashback-purchase-v2';
import RakeBackSkeleton from '../cpns-skeleton/rake-back-skeleton';

export default {
  name: 'RakeBack',
  components: {
    CashbackPurchase,
    CashbackPurchaseV2,
    CommonLoadBox,
    RakeBackSkeleton,
  },
  props: {
    // 电商返佣模块信息
    rakeBackModuleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['getStyleVersion'],
  provide() {
    return {
      cashbackStyleVersion: () => this.rakeBackModuleInfo?.moduleKey || 'welfare_rake_back',
    };
  },
  data() {
    return {
      // 剪贴板读取定时器
      readClipboardTimer: null,
      // 电商返佣模块加载状态
      rakeBackloaded: false,
      // 是否重新加载组件
      reload: false,
    };
  },
  computed: {
    currentCashbackComponent() {
      const { moduleKey } = this.rakeBackModuleInfo || {};
      return MODULE_KEY_CASHBACK_STYLE[moduleKey] || MODULE_KEY_CASHBACK_STYLE.welfare_rake_back;
    },
  },
  activated() {
    this.reload = false;
  },
  deactivated() {
    this.reload = true;
  },
  destroyed() {
    // 销毁定时器
    if (this.readClipboardTimer) {
      clearTimeout(this.readClipboardTimer);
    }
  },
  methods: {
    moduleExpose() {
      // 电商返佣模块曝光
      SPM.moduleExpose({
        moduleId: 'Welfare_onlineretailers',
        contentId: 'Welfare_onlineretailers',
        exposureTimes: 1,
        businessInfo: {
          takeoutTestVersion: this.rakeBackModuleInfo?.moduleKey || 'welfare_rake_back',
        },
      });
    },
    // 激励金刷新
    handleBountyRefresh() {
      this.$emit('bounty');
    },
    // 电商返佣模块加载完成
    handleLoaded() {
      this.rakeBackloaded = true;
      // 读取剪贴板（新版改为实验后组件内无这个方法）
      this.readClipboardTimer = setTimeout(() => {
        const { cashbackPurchaseRef } = this.$refs || {};
        if (cashbackPurchaseRef && cashbackPurchaseRef.readClipboard) {
          cashbackPurchaseRef.readClipboard();
        }
      }, 1000);
    },
  },
};
</script>
